import { formatSelectionsArray, truncateSelectedValues } from './utils'
import { seatsData } from '@cinch-nx/data-search'

export const getFormattedSeats = (seatSelections: string[] = []) =>
  truncateSelectedValues(formatSelectionsArray(seatSelections, seatsData))
